import { v2neutral300 } from '@paypalcorp/pp-react'
import { greyBackgroundAndSmaller } from 'lib/styles/media-queries'

export const BOX_BORDER_STYLES = {
  border: `1px solid ${v2neutral300}`,
  borderRadius: '0.875rem',
  [greyBackgroundAndSmaller]: {
    border: 'none',
    borderRadius: 0,
  },
}
